module.exports = __webpack_public_path__ + "img/arrow-expand.5277d6b2.svg";